<template>
  <div class="evaluation">
    <!-- 汇总信息 -->
    <template v-if="dataList.length">
      <!-- 列表展示信息 -->
      <div
        class="bg-F6F6F6 hidden"
        v-if="+type === 1 || +type === 2"
        key="more"
      >
        <div
          class="list-card bg-FFFFFF bd-radio-8 p-0-16 p-12-0 c-171A1D"
          @click="handlerDetail(item)"
          v-for="item in dataList"
          :key="item.deptDingId"
        >
          <p class="font-30 text-bold pb-12">{{ item.deptName }}</p>
          <div class="pt-1 fb fb-cross-center fb-main-between">
            <div class="item-flex-1 text-center p-0-5">
              <p class="font-30 ff-medium pb-2 text-bold-600 break-all">
                {{ item.totalCount || 0 }}
              </p>
              <p class="font-24 c-171A1D-60 ff-regular">学生总数</p>
            </div>
            <div class="item-flex-1 text-center">
              <p class="font-30 ff-medium pb-2 text-bold-600 break-all">
                {{ item.selectCount || 0 }}
              </p>
              <p class="font-24 c-171A1D-60 ff-regular">选课人次</p>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="bg-F6F6F6 hidden" key="single">
        <div
          class="student-list-item"
          v-for="st in dataList"
          :key="st.studentDingId"
        >
          <div
            class="student-avator fb fb-cross-center fb-main-center font-28"
            >{{ st.studentName | nameFilter }}</div
          >
          <div class="student-name-gender fb fb-cross-center">
            <div class="student-name font-34 c-171A1D lh-24 text-ellipsis">{{
              st.studentName
            }}</div>
            <div class="student-gender ml-4" v-if="st.gender > 0">
              <span
                class="font-32 iconfont"
                :style="{
                  color: st.gender === 1 ? '#006AFE' : '#FF4D94'
                }"
                >{{ st.gender ? '&#xe685;' : '&#xe686;' }}</span
              >
            </div>
          </div>
          <div
            class="elective-class-name font-28 c-171A1D-60 lh-20 ellipsis-l2 mt-8"
            >{{ st.electiveClassNames.join('、') }}</div
          >
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { nameLastTwoWords } from '@/utils/comUtils'
export default {
  name: 'elective',
  props: {
    // 组件的类型  1-2 类型样式一致
    type: {
      type: [Number, String],
      default: 3
    },

    dataList: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    nameFilter(name) {
      return nameLastTwoWords(name)
    }
  },
  methods: {
    handlerDetail(item) {
      this.$emit('detail', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.dot {
  display: block;
  width: 4px;
  height: 8px;
  flex-shrink: 0;
  margin-right: 4px;
}
.list-card {
  margin: 20px 0;
}
.break-all {
  word-break: break-all;
}

.fm-helvetica {
  font-family: Helvetica, Helvetica-Bold;
}

.list-item {
  flex: 1;
  width: 33.33333333%;
  text-align: center;
  padding: 12px 4px;
  font-size: 14px;
  &.title {
    padding: 0 4px 12px;
  }
}

.triangle {
  $triangle_width: 4px;
  width: 0;
  height: 0;
  border-right: $triangle_width solid transparent;
  border-left: $triangle_width solid transparent;
  &.up {
    border-bottom: $triangle_width solid rgba(17, 31, 44, 0.4);
    &.active {
      border-bottom: $triangle_width solid #006afe;
    }
  }
  &.down {
    border-top: $triangle_width solid rgba(17, 31, 44, 0.4);
    &.active {
      border-top: $triangle_width solid #006afe;
    }
  }
}
.student-list-item {
  background-color: #fff;
  position: relative;
  padding: 22px 16px 16px 64px;
  .student-avator {
    position: absolute;
    top: 16px;
    left: 16px;
    width: 36px;
    height: 36px;
    background-color: #006afe;
    border-radius: 999px;
    color: #fff;
    // background-size: 100%;
    // background-repeat: no-repeat;
  }
  &::after {
    position: absolute;
    content: ' ';
    bottom: 1px;
    left: 64px;
    right: 0;
    background: rgba(126, 134, 142, 0.16);
    height: 1px;
  }
  &:nth-last-of-type(1) {
    border-radius: 0 0 8px 8px;
    &::after {
      display: none;
    }
  }
  &:first-child {
    border-radius: 8px 8px 0px 0px;
  }
}
</style>
